import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { ManageServicePathName } from '@/modules/ta/manageservice/manageservice.constants';
import { RouteGroup } from '@/modules/core/app/constants/api.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: '/sup/service/manage',
      alias: RouteGroup.CONNECT_DATA,
      name: ManageServicePathName.SUP_MANAGE_SERVICE,
      component: () =>
        import(
          /* webpackChunkName: "sup-servicemanage-page" */ '@/modules/ta/manageservice/pages/ManageServicePage'
        ),
    },
    {
      path: '/sup/service/manage/connection',
      name: ManageServicePathName.SUP_SERVICE_MANAGE_CONNECTION,
      component: () =>
        import(
          /* webpackChunkName: "sup-servicemanageconnection-page" */ '@/modules/ta/manageservice/pages/ManageConnectionPage'
        ),
    },
    {
      path: '/sup/service/manage/:id',
      name: ManageServicePathName.SUP_MANAGE_SERVICE_ACCOUNTS,
      component: () =>
        import(
          /* webpackChunkName: "serviceassignment-page" */ '@/modules/ta/manageservice/pages/ManageServiceAccountsPage'
        ),
    },
    {
      path: '/connectdata/:id',
      redirect: (to) => `/sup/service/manage/${to.params.id}`,
    },
    {
      path: '/sup/service/manage/:id/tab/:tabName',
      name: ManageServicePathName.SUP_MANAGE_SERVICE_ACCOUNTS_DETAILS,
      component: () =>
        import(
          /* webpackChunkName: "serviceassignment-page" */ '@/modules/ta/manageservice/pages/ManageServiceAccountsPage'
        ),
    },
  ],
  Module.SERVICE
);
